import React from 'react';
import { useTranslation } from 'react-i18next';

import ListResource from './ListResource.jsx';
import { getLang } from '~/commons/helpers';
import { env } from '../../config';

const api = '/api/core/users/students';

const ListAchievements = ({ level }) => {
  const { rows = [], totalBadges } = level;
  const isAdmin = env?.user?.roles?.includes('admin');
  const { i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';
  const findLevel = (s) => rows.find((v) => s >= v.score);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          { value: 'schoolClass.title', label: 'Class' },
          {
            value: 'schoolClass.grade',
            label: 'Grade',
            options: Object.keys(env.grades).map((g) => ({
              value: g,
              label: env.grades[g][lang],
            })),
          },
          ...isAdmin ? [{
            value: 'school.title', label: 'School',
          }] : [],
        ],
        actions: {
          create: false,
          remove: false,
          find: false,
        },
        api,
        sort: { score: 1 },
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => getLang(r.name.full, lang),
          },
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => env.lvs[v][lang],
          },
          {
            key: 'schoolClass.acadYear',
            children: 'Year',
            getter: (v) => (`${v}/${v+1}`),
          },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            getter: (v) => env.grades[v][lang],
          },
          {
            key: 'studentNo',
            children: 'Class No.',
          },
          {
            key: 'badges',
            children: 'Badges',
            getter: (v) => (`${v.length}/${totalBadges}`),
          },
          {
            key: 'acuScore',
            children: 'Level',
            sortable: true,
            getter: (v) => findLevel(v)?.title?.zhhk || '',
          },
        ],
      }}
    >
    </ListResource >
  );
};

export default ListAchievements;
